import React, { useState } from "react";
import Contacts from "@/pages/contacts";

const Ukstudentvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/ukimg.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
        
        </div>
      </div>
      <div className="mt-10 w-full px-5 md:w-3/4 md:ml-20 lg:ml-32 text-center md:text-left text-3xl font-bold text-black drop-shadow-md">
  Step Into World-Class Education with the UK Student Visa
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-4">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/ukstudent.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-10 lg:w-1/2">
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
     <a className="text-black font-bold"> Exceptional Academic Standards:</a>Study at some of the world’s most esteemed universities and institutions, known for their quality education.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Rich Cultural Experience:</a> Immerse yourself in a diverse and inclusive environment, interacting with peers from across the globe.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Enhanced Career Prospects:</a> A degree from a UK university significantly boosts your employability in the global job market.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Work Opportunities During Studies:</a> Gain practical experience and financial support by working part-time while studying and full-time during holidays.
    </span>
  </div>
</div>



      </div>
      
      <div className="mt-10 w-full px-5  md:w-full md:px-20 lg:mt-10 xl:mt-10">
  <p className="mb-5 text-center text-3xl font-bold text-[#011473] md:text-5xl">
  UK Student Visa Categories
  </p>
  <div className="container mx-auto mb-10 mt-14">
  <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-2">
    <div className="flex items-center justify-center">
      <img
        src="/bussines.jpg" // Replace with your image URL
        alt="Student Visas"
        className="w-full h-auto rounded-xl shadow-md"
      />
    </div>
    <div className="flex flex-col text-black justify-left text-left md:text-left pl-4">
      <ul className="list-disc space-y-10 pl-5 mb-4">
        <li><strong>Tier 4 (General) Student Visa:</strong> Available for students aged 16 and above, allowing full-time enrollment at a recognized UK institution.</li>
        <li><strong>Short-Term Study Visa:</strong> Designed for students attending short courses or English language programs for up to 11 months, with no extension beyond the initial duration.</li>
        <li><strong>Child Student Visa:</strong> For children aged 4 to 17 who wish to study at an independent school in the UK.</li>
      </ul>
    </div>
  </div>
</div>

</div>

<div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
  <p className="mb-5 text-center text-3xl font-bold text-[#011473] md:text-5xl">
  UK Student Visa application tips:
  </p>
  <div className="container mx-auto mb-10 mt-14">
  <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-2">
    <div className="flex flex-col justify-left text-left md:text-left pl-4">
      <ul className="list-disc pl-5 text-black space-y-10 mb-4">
        <li><strong>Begin Early:</strong> Initiate your application promptly after receiving your Confirmation of Acceptance for Studies (CAS).</li>
        <li><strong>Ensure Complete Documentation:</strong> Double-check that all required documents are accurate and submitted in full.</li>
        <li><strong>Prepare Financially:</strong> Keep the necessary funds in your bank account for a minimum of 28 days prior to applying.</li>
        <li><strong>Prove English Proficiency:</strong> Attain the required score on an approved English language test.</li>
      </ul>
    </div>
    <div className="flex items-center justify-center">
      <img
        src="/bussines.jpg" // Replace with your image URL
        alt="Visa World Business"
        className="w-full h-96 rounded-xl shadow-md"
      />
    </div>
  </div>
</div>

</div>

      
<div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center text-black justify-center rounded-md bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        - <strong>Prestigious Institutions</strong>: The UK is home to world-renowned universities offering diverse academic programs across various fields.
        <br />
        - <strong>Globally Recognized Qualifications</strong>: A UK Student Visa grants you the opportunity to earn internationally respected degrees and certifications.
        <br />
        - <strong>Seamless Application Process</strong>: Visa World provides expert guidance through every stage of your UK Student Visa application, ensuring a smooth and efficient experience.
        <br />
        - <strong>Pathway to Academic Excellence</strong>: Studying in the UK opens doors to a wealth of academic and professional opportunities, allowing you to excel in your chosen field.
        <br />
        At Visa World, we are committed to supporting your educational aspirations in the UK and making the visa process as straightforward as possible.
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Study in the UK with a Tier 4 (General) Student Visa
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>




      <Contacts />
    </>
  );
};

export default Ukstudentvisa;
